import { HeartBank } from "../../../../managers/HeartBank.ts";
import { Humanity } from "../../../../managers/Humanity.ts";

import template from "./hb-mithril.mjs";
import { render } from "lit-html";
import { HbMain } from "../../../hb-main/hb-main.ts";

export class HbMithril extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private humanity: Humanity = new Humanity();
    private main = document.querySelector("hb-main") as HbMain;

    private mithril: HTMLFormElement;
    private username: HTMLInputElement;
    private usernameBtn: HTMLButtonElement;
    private number: HTMLInputElement;
    private numberBtn: HTMLButtonElement;

    constructor() {
        super();
        render(template(), this);

        this.mithril = this.querySelector("#hb-mithril")!;
        this.username = this.querySelector("#hb-mithril-username")!;
        this.usernameBtn = this.querySelector("#hb-mithril-username-btn")!;
        this.number = this.querySelector("#hb-mithril-number")!;
        this.numberBtn = this.querySelector("#hb-mithril-number-btn")!;
    }

    connectedCallback() {
        this.usernameBtn.addEventListener(
            "click",
            this.updateUsername.bind(this)
        );

        this.numberBtn.addEventListener(
            "click",
            this.handleRemoveNumber.bind(this)
        );

        this.heartbank.addAuthStateListener((user) => {
            render(template(user), this);
        });
    }

    rerender() {
        render(template(this.heartbank.user), this);
    }

    show() {
        this.mithril.classList.remove("hidden");
    }

    hide() {
        this.mithril.classList.add("hidden");
    }

    private dispatch(message: string, color: string) {
        const event = new CustomEvent<{ message: string; color: string }>(
            "hb-humanity",
            {
                detail: { message, color },
                bubbles: true, // allows the event to bubble up the DOM
                composed: true // allows it to pass through shadow DOM
            }
        );
        this.dispatchEvent(event);
    }

    // TODO: later only allow edit username after 1 month? can do via security rule... require passkey?? maybe time limit is good enough
    private async updateUsername(event: Event) {
        event.preventDefault();
        this.main.showSpinner();

        if (this.heartbank.user?.phoneNumber) {
            const username = this.username.value.trim();
            if (username) {
                try {
                    const status = await this.humanity.updateUsername(username);
                    this.username.placeholder = username;
                    this.main.renderSilver(this.heartbank.user);
                    this.dispatch(status, "green");
                } catch (error: any) {
                    this.dispatch(error.message, "red");
                }
            }
        } else {
            this.dispatch(
                "Sorry, only humans with a Heart of Mithril or above can create a username. Please prove your humanity by confirming your phone number.",
                "red"
            );
        }

        this.main.hideSpinner();
    }

    // not used
    private async handleRemoveNumber(event: Event) {
        if (
            confirm(
                "Removing your phone number will revert your Heart to Silver and cause you to lose some features. Are you sure?"
            )
        ) {
            //event.preventDefault();
            this.main.showSpinner();
            const status = await this.heartbank.removePhoneNumber();

            if (status.color === "green") render(template(status.user), this);
            this.dispatch(status.text, status.color);
            this.main.hideSpinner();
        }
    }
}
